import {Box} from '@mui/material';
import React, {useEffect, useMemo, useState} from 'react';
import {shortenName} from '../../../../utils/shortenName';
import {useAccountContext} from '../../../../contexts/AccountContext';
import OWNERSHIP from '../../../../constants/Ownership';
import {useReviewContext} from '../../../../contexts/ReviewContext';
import {builderFieldsType} from '../builderFields';
import {useBuilderContext} from '../useBuilderContext';
import AutoField, {
  ActionType,
  RadioGroupField,
  SelectOption,
} from '../../../../components/AutoForm/AutoFieldNew';
import {useAutoForm} from '../../../../components/AutoForm/useAutoForm';
import {AccountBasicFragment_contacts} from '../../../../schema-types/AccountBasicFragment';
import {loadWhoBuilds, setBuilderContact} from '../../hooks/createBuilderHooks';

interface BuilderWhoOptionsProps {
  isSubmitting: boolean;
  contacts: AccountBasicFragment_contacts[];
  visible: boolean;
}

export function BuilderWhoOptions(props: BuilderWhoOptionsProps) {
  const {isSubmitting, contacts, visible} = props;
  const {values, setFieldValue} = useAutoForm<builderFieldsType>();
  const [selectedLabel, setLabel] = useState('for...');
  const {account, accountId} = useAccountContext();
  const {reviewDetails, reviewValidation: review} = useReviewContext();
  const {builderDetails} = useBuilderContext();

  // useEffect(() => {
  //   if (values.contact) {
  //     return;
  //   }
  //   loadWhoBuilds({
  //     builderDetails,
  //     setFieldValue,
  //     reviewDetails,
  //     account,
  //   });
  // }, [builderDetails, reviewDetails, values.contact]);

  useEffect(() => {
    setBuilderContact({
      contacts,
      setFieldValue,
      setLabel,
      reviewDetails,
      builderDetails,
      values,
      account,
    });
  }, [values.contact, contacts, builderDetails, reviewDetails]);
  const field: RadioGroupField = useMemo(() => {
    const EXCLUDED_STATUSES = ['Deceased', 'Departed'];
    let options: SelectOption[] = contacts
      .filter(
        (c) =>
          !EXCLUDED_STATUSES.includes(c.contactStatus as string) ||
          review?.statusOneview === 'CLOSED'
      )
      .map((contact) => ({
        value: contact.id,
        label: shortenName(contact.simplifiedName as string)!,
        disabled: isSubmitting,
      }));
    if (account?.secondaryContact) {
      options.push({
        value: OWNERSHIP.JOINT_CODE,
        label: 'Joint',
      });
    }

    if (account?.isTrust) {
      options = [
        {
          value: OWNERSHIP.TRUST,
          label: 'Trust',
        },
      ];
    }

    return {
      id: 'contact',
      label: account?.isTrust ? 'For account' : 'For contact',
      boldLabel: true,
      type: ActionType.radioGroup,
      options,
    };
  }, [contacts, account?.secondaryContact?.id]);
  return (
    <Box visibility={visible ? 'visible' : 'hidden'}>
      <AutoField field={field} />
    </Box>
  );
}
